import { Building2, TrendingUp, Users, Award, Home, MapPin, Clock, Shield } from 'lucide-react';
const  avt = "../../../assets/images/avt.jpg"
export const teamMembers = [
  {
    id: 1,
    name: 'Đạt Nguyễn',
    position: 'Head of Product',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=300&fit=crop'
  },
  {
    id: 2,
    name: 'Dương Đặng',
    position: 'Head of Business',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=300&h=300&fit=crop'
  },
  {
    id: 3,
    name: 'Okuto Nakamura',
    position: 'General Director',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=300&h=300&fit=crop'
  },
  {
    id: 4,
    name: 'Công Vinh',
    position: 'Software of Engineering',
    image: "https://scontent.fsgn21-1.fna.fbcdn.net/v/t39.30808-1/559514427_1346594247168360_5790191528266980132_n.jpg?stp=dst-jpg_s200x200_tt6&_nc_cat=101&ccb=1-7&_nc_sid=1d2534&_nc_ohc=mvzB9Zw-4-4Q7kNvwFTqe9N&_nc_oc=Adn2oGrwkHLUoSw3jUyY4sTBic3xx8yGYV3nx0lLILuZKzM76c25f7Z93Uqj2NbIzGY&_nc_zt=24&_nc_ht=scontent.fsgn21-1.fna&_nc_gid=mxfMmjsF8AVpaOu77t8kNg&oh=00_AfiD-UNzDdARbVk_H_JjrOk0F1cZ-ky7LqVv_SWJf0eJsg&oe=6925041C"
  },
  {
    id: 5,
    name: 'Yên Phùng',
    position: 'Head of Marketing',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=300&h=300&fit=crop'
  }
];


  export const leaders = [
    {
      name: 'Đạt Nguyễn',
      position: 'Head of Product',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=300&fit=crop'
    },
    {
      name: 'Dương Đặng',
      position: 'Head of Business',
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=300&h=300&fit=crop'
    },
    {
      name: 'Okuto Nakamura',
      position: 'General Director',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=300&h=300&fit=crop'
    },
    {
      name: 'Phí Huyền',
      position: 'Head of Engineering',
      image: 'https://images.unsplash.com/photo-1502764613149-7f3107cda4cb?w=300&h=300&fit=crop'
    },
    {
      name: 'Yên Phùng',
      position: 'Head of Marketing',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=300&h=300&fit=crop'
    }
  ];

   export const features = [
    {
      icon: Building2,
      title: 'Danh mục đa dạng',
      description: 'Hàng ngàn tin đăng bất động sản từ căn hộ, nhà phố đến đất nền, villa cao cấp.',
      gradient: 'blue-cyan'
    },
    {
      icon: TrendingUp,
      title: 'Phân tích thị trường',
      description: 'Cập nhật xu hướng, biến động giá và cơ hội đầu tư bất động sản theo thời gian thực.',
      gradient: 'cyan-teal'
    },
    {
      icon: Shield,
      title: 'Tin cậy & Minh bạch',
      description: 'Xác minh thông tin, pháp lý rõ ràng, cam kết bảo vệ quyền lợi khách hàng.',
      gradient: 'teal-green'
    },
    {
      icon: Clock,
      title: 'Hỗ trợ 24/7',
      description: 'Đội ngũ tư vấn chuyên nghiệp sẵn sàng hỗ trợ mọi lúc, mọi nơi.',
      gradient: 'green-emerald'
    },
  ];

   export const stats = [
    { icon: Home, value: '10,000+', label: 'Tin đăng BĐS', color: 'blue-cyan' },
    { icon: Users, value: '5,000+', label: 'Khách hàng tin tưởng', color: 'cyan-teal' },
    { icon: MapPin, value: '63', label: 'Tỉnh thành phủ sóng', color: 'teal-green' },
    { icon: Award, value: '99%', label: 'Hài lòng khách hàng', color: 'green-emerald' },
  ];

  export  const propertyTypes = [
    { name: 'Căn hộ chung cư', count: '3,500+', image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=400&h=300&fit=crop' },
    { name: 'Nhà riêng', count: '2,800+', image: 'https://images.unsplash.com/photo-1761839257658-23502c67f6d5?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' },
    { name: 'Đất nền dự án', count: '1,900+', image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=400&h=300&fit=crop' },
    { name: 'Villa cao cấp', count: '850+', image: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=400&h=300&fit=crop' },
  ];